import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsQgisComponent } from './simple-icons-qgis.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsQgisComponent ],
    exports:      [ SimpleIconsQgisComponent ],
    bootstrap:    []
})
export class SimpleIconsQgisModule {}
